import BaseModule from "~/vuex/modules/base-module";

let CruiseCabins = {...BaseModule};

CruiseCabins.state = function () {
    let state = BaseModule.state();

    //state.endpoints['all'] = '/api/....';

    state.lastDate = null;
    state.sort = {};


    return state;
};

CruiseCabins.actions.getByCruiseId = async function ({ commit, dispatch, getters, state, rootGetters }, data = {}) {
    if (data.cruiseId === undefined) {
        return false;
    }

    data.endpoint = '/api/cruises/' + data.cruiseId + '/cabins';

    return dispatch('getAll', data);
};


export default CruiseCabins;